var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useRef } from 'react';
import { GlobalModel } from '../../models';
import { useCallbackExtended } from '../useCallbackExtended/useCallbackExtended';
export const useCallbackDebouncedPromisified = ({ comparator, fn, fnDeps = [], timeout, }) => {
    _react_refresh_temp_1();
    const rafIdInfoRef = useRef(null);
    const fnDebounce = useCallbackExtended((...args) => {
        return new Promise((resolve, reject) => {
            if (rafIdInfoRef.current) {
                GlobalModel.clearRAFTimeout(rafIdInfoRef.current);
            }
            // eslint-disable-next-line @typescript-eslint/no-misused-promises -- Intentional
            rafIdInfoRef.current = GlobalModel.setRAFTimeout(async () => {
                try {
                    resolve(await fn(...args));
                }
                catch (error) {
                    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- forwarding the caught rejection unchanged
                    reject(error);
                }
            }, timeout);
        });
    }, fnDeps, comparator);
    return fnDebounce;
};
_react_refresh_temp_1(useCallbackDebouncedPromisified, "pITD85FzVXhOr05FxKXah1F4JKY=", false, () => [useCallbackExtended]);
